module.exports = __webpack_public_path__ + "static/radikal_medium-webfont-29410cc3fc1759ce4e4a2ee47c42f79c.woff2";